import { DatePreset } from '../models/DatePreset';
import { Injectable } from '@angular/core';
import moment from 'moment';

export enum DatePresetServiceType {
  Custom = 'custom',
  Today = 'today',
}
@Injectable({
  providedIn: 'root',
})
export class DatePresetService {
  constructor() {}

  getDatePreset(
    datePreset: DatePreset[],
    startDate: moment.Moment,
    endDate: moment.Moment,
    dateFormat: string,
    addToday = true
  ) {
    if (!datePreset) {
      return;
    }

    if (
      addToday &&
      !datePreset.find((element) => element.id === DatePresetServiceType.Today)
    ) {
      const todayDatePreset = {
        id: DatePresetServiceType.Today,
        label: DatePresetServiceType.Today,
        startDate: moment(),
        endDate: moment(),
      };
      datePreset.push(todayDatePreset);
    }

    let selectedDatePreset: DatePreset = null;

    datePreset.forEach((item) => {
      if (
        startDate.format(dateFormat) === item.startDate.format(dateFormat) &&
        endDate.format(dateFormat) === item.endDate.format(dateFormat)
      ) {
        selectedDatePreset = item;
      }
    });

    if (selectedDatePreset) {
      return selectedDatePreset;
    }

    const result = datePreset.filter(
      (item) => item.id === DatePresetServiceType.Custom
    );

    if (result.length > 0) {
      const item = result[0];
      item.startDate = startDate;
      item.endDate = endDate;
      return item;
    } else {
      selectedDatePreset = {
        id: DatePresetServiceType.Custom,
        label: DatePresetServiceType.Custom,
        startDate,
        endDate,
      };
      datePreset.push(selectedDatePreset);
      return selectedDatePreset;
    }
  }
}
